import { render, staticRenderFns } from "./wa-chatbot.vue?vue&type=template&id=f05a0cac&scoped=true&"
import script from "./wa-chatbot.vue?vue&type=script&lang=js&"
export * from "./wa-chatbot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05a0cac",
  null
  
)

export default component.exports